import ApiService from "../api.service";
const ReportService = {
  GetReportPurchaseRequisition(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    OrganizationId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit
  ) {
    return ApiService.get(
      `/Report/GetReportPurchaseRequisition?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  PrintReportPurchaseRequisition(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    OrganizationId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit
  ) {
    return ApiService.print(
      `/Report/PrintReportPurchaseRequisition?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  GetPurchasedProductsList(
    OblastId,
    RegionId,
    ProductCategoryId,
    ProductId,
    FinYear,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit
  ) {
    return ApiService.get(
      `/Report/GetPurchasedProductsList?OblastId=${OblastId}&RegionId=${RegionId}&ProductCategoryId=${ProductCategoryId}&ProductId=${ProductId}&FinYear=${FinYear}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  GetAuctionLotInfo(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    LotId,
    sellerinn,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&LotId=${LotId}&sellerinn=${sellerinn}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  PrintAuctionLotInfo(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    LotId,
    sellerinn,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.print(
      `/Report/PrintAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&LotId=${LotId}&sellerinn=${sellerinn}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetAuctionInfoByStatus(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatus?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetAuctionInfoByProvider(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ProviderId,
    ProductCategoryId,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByProvider?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ProviderId=${ProviderId}&ProductCategoryId=${ProductCategoryId}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetAuctionInfoByProviderPlatformAuction(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByProviderPlatformAuction?ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByProviderPlatformAuction(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByProviderPlatformAuction?ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByProviderPlatformShop(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByProviderPlatformShop??ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByProviderPlatformShop(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByProviderPlatformShop?ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByProviderPlatformEtender(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByProviderPlatformEtender??ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByProviderPlatformEtender(
    ProviderId,
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByProviderPlatformEtender?ProviderId=${ProviderId}&OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },

  GetAuctionInfoByStatusShop(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusShop?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByStatusShop(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByStatusShop?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByStatusAuction(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusAuction?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByStatusAuction(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByStatusAuction?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByStatusEtender(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusEtender?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByStatusEtender(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByStatusEtender?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByBuyer(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ProductCategoryId,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByBuyer?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ProductCategoryId=${ProductCategoryId}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetAuctionInfoByBuyerPlatfromAuction(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByBuyerPlatfromAuction?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByBuyerPlatfromAuction(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByBuyerPlatfromAuction?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByBuyerPlatfromShop(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByBuyerPlatfromShop?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByBuyerPlatfromShop(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByBuyerPlatfromShop?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByBuyerPlatfromEtender(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByBuyerPlatfromEtender?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintAuctionInfoByBuyerPlatfromEtender(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintAuctionInfoByBuyerPlatfromEtender?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  BudgetAuctionList(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ProviderId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/BudgetAuctionList?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ProviderId=${ProviderId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetTopMaxLotCountAuctionInfoByProviderPlatformAuction(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxLotCountAuctionInfoByProviderPlatformAuction?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxLotCountAuctionInfoByProviderPlatformAuction(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxLotCountAuctionInfoByProviderPlatformAuction?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintBudgetAuctionList(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    LotId,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintBudgetAuctionList?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetBudgetShopList(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetBudgetShopList?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetBudgetEtenderList(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetBudgetEtenderList?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetBudgetDirectlyList(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit
  ) {
    return ApiService.get(
      `/Report/GetBudgetDirectlyList?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  GetBudgetOtborList(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    ProductCategoryId,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit
  ) {
    return ApiService.get(
      `/Report/GetBudgetOtborList?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&ProductCategoryId=${ProductCategoryId}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  GetBudgetTenderList(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetBudgetTenderList?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  PrintBudgetTenderList(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    ItemGroupName
  ) {
    return ApiService.print(
      `/Report/PrintBudgetTenderList?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionLotInfoStakan(LotId) {
    return ApiService.get(`/Report/GetAuctionLotInfoStakan?LotId=${LotId}`);
  },
  GetBudgetAuctionStakan(LotId) {
    return ApiService.get(`/Report/GetBudgetAuctionStakan?LotId=${LotId}`);
  },
  GetTopMaxEconomyCostAuctionLotInfo(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetTopMaxEconomyCostAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  PrintTopMaxEconomyCostAuctionLotInfo(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.print(
      `/Report/PrintTopMaxEconomyCostAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetTopMaxParticipantsCountAuctionLotInfo(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.get(
      `/Report/GetTopMaxParticipantsCountAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  PrintTopMaxParticipantsCountAuctionLotInfo(
    OblastId,
    RegionId,
    StartDate,
    EndDate,
    ItemGroupName,
    TradeTypeId
  ) {
    return ApiService.print(
      `/Report/PrintTopMaxParticipantsCountAuctionLotInfo?OblastId=${OblastId}&RegionId=${RegionId}&StartDate=${StartDate}&EndDate=${EndDate}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}`
    );
  },
  GetTopMaxLotCountAuctionInfoByProvider(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxLotCountAuctionInfoByProvider?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetReportForDashboard(tradetypeid, StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetReportForDashboard?tradetypeid=${tradetypeid}&StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetTopMaxLotCountAuctionInfoByProviderPlatformShop(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxLotCountAuctionInfoByProviderPlatformShop?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxLotCountAuctionInfoByProviderPlatformShop(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxLotCountAuctionInfoByProviderPlatformShop?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetTopMaxLotCountAuctionInfoByProviderPlatformEtender(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxLotCountAuctionInfoByProviderPlatformEtender?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxLotCountAuctionInfoByProviderPlatformEtender(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxLotCountAuctionInfoByProviderPlatformEtender?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxTotalCostAuctionInfoByProviderPlatformAuction(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxTotalCostAuctionInfoByProviderPlatformAuction?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetTopMaxTotalCostAuctionInfoByProviderPlatformShop(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxTotalCostAuctionInfoByProviderPlatformShop?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxTotalCostAuctionInfoByProviderPlatformShop(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxTotalCostAuctionInfoByProviderPlatformShop?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  PrintTopMaxTotalCostAuctionInfoByProviderPlatformEtender(StartDate, EndDate) {
    return ApiService.print(
      `/Report/PrintTopMaxTotalCostAuctionInfoByProviderPlatformEtender?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  // GetAuctionInfoByBuyerPlatfromAuction(StartDate, EndDate) {
  //   return ApiService.get(
  //     `/Report/GetAuctionInfoByBuyerPlatfromAuction?StartDate=${StartDate}&EndDate=${EndDate}`
  //   );
  // },
  GetTopMaxTotalCostAuctionInfoByProvider(StartDate, EndDate) {
    return ApiService.get(
      `/Report/GetTopMaxTotalCostAuctionInfoByProvider?StartDate=${StartDate}&EndDate=${EndDate}`
    );
  },
  GetProvidersByCategoryRisk() {
    return ApiService.get(`/Report/GetProvidersByCategoryRisk`);
  },
  GetLotsByDumpingRisk(providerInn, buyerInn) {
    return ApiService.get(
      `/Report/GetLotsByDumpingRisk?providerInn=${providerInn}&buyerInn=${buyerInn}`
    );
  },
  GetBuyersByProviderRisk() {
    return ApiService.get(`/Report/GetBuyersByProviderRisk`);
  },
  GetAllUzexLot(
    OblastId,
    RegionId,
    OrganizationId,
    ItemGroupName,
    TradeTypeId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    summa
  ) {
    return ApiService.get(
      `/Report/GetAllUzexLot?OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&summa=${summa}`
    );
  },
  PrintAllUzexLot(
    OblastId,
    RegionId,
    OrganizationId,
    ItemGroupName,
    TradeTypeId,
    StartDate,
    EndDate,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    Summa
  ) {
    return ApiService.print(
      `/Report/PrintAllUzexLot?OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}&ItemGroupName=${ItemGroupName}&TradeTypeId=${TradeTypeId}&StartDate=${StartDate}&EndDate=${EndDate}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&Summa=${Summa}`
    );
  },
};
export default ReportService;
